import React, { useEffect } from 'react'
import { Col, Form } from 'react-bootstrap'
import { CustomAnswer, CustomQuestion, CustomQuestionType } from '../../store/events/interfaces'
import { FieldError, FieldValues, FormState, UseFormRegister, UseFormSetValue, UseFormTrigger } from 'react-hook-form'
import { useAppSelector } from '../../hooks'

const renderSelectQuestions = (props: {
  question: CustomQuestion
  register: UseFormRegister<FieldValues>
  loadedViaCode: boolean
  answeredQuestions: number[]
  errors: Record<string, any>
  formState: FormState<FieldValues>
  defaultValue: (question: CustomQuestion) => string
}) => {
  const {
    question,
    register,
    errors,
    loadedViaCode,
    answeredQuestions,
    formState,
    defaultValue,
  } = props
  const value = defaultValue(question)

  return (
    <>
      <Form.Control
        {...register(`custom_answer$${question.id}`)}
        required={question.required}
        as='select'
        defaultValue={value}
        disabled={
          loadedViaCode &&
          answeredQuestions.includes(question.id)
        }
        isValid={
          formState.touchedFields[`custom_answer$${question.id}`] &&
          !errors[`custom_answer$${question.id}`]
        }
        isInvalid={!!errors[`custom_answer$${question.id}`]}
      >
        {question.type === CustomQuestionType.YESNO ? (
          <>
            <option value='' />
            <option value='Ja'>Ja</option>
            <option value='Nein'>Nein</option>
          </>
        ) : (
          <>
            <option />
            {question.choices.map((choice: string) => (
              <option value={choice}
                key={`${question.id}_${question.choices.findIndex(
                  c => c === choice,
                )}`}
              >
                {choice}
              </option>
            ))}
          </>
        )}
      </Form.Control>
      <Form.Control.Feedback type='invalid'>
        {errors[`custom_answer$${question.id}`]
          ? (errors[`custom_answer$${question.id}`] as FieldError).message
          : ''}
      </Form.Control.Feedback>
    </>
  )
}

export const ParticipantCustomQuestions = (props: {
  questions: CustomQuestion[]
  register: UseFormRegister<FieldValues>
  loadedViaCode: boolean
  setValue: UseFormSetValue<FieldValues>
  errors: Record<string, any>
  formState: FormState<FieldValues>
}) => {
  const { questions, register, errors, loadedViaCode, formState, setValue } = props
  const { answeredParticipantCustomQuestions: answeredCustomQuestions } = useAppSelector(
    (state) => state.program,
  )
  const { data: participant } = useAppSelector(
    (state) => state.participant,
  )

  const defaultValue = (question: CustomQuestion) => {
    return participant.custom_answers !== undefined &&
    participant.custom_answers.find(
      (q: CustomAnswer) => q.question_id === question.id,
    ) !== undefined
      ? (participant.custom_answers.find(
        (q: CustomAnswer) => q.question_id === question.id,
      ) as CustomAnswer).answer_text
      : ''
  }

  if(loadedViaCode) {
    questions.map((question: CustomQuestion) => (
      setValue(`custom_answer$${question.id}`, defaultValue(question))
    ))
  }

  if (questions.length === 0) {
    return <></>
  }
  return (
    <>
      <Form.Row>
        <h5>Weitere Daten</h5>
      </Form.Row>
      {questions.map((question: CustomQuestion) => (
        <Form.Row key={`custom_answer$${question.id}`}>
          <Col>
            <Form.Group controlId={`custom_answer$${question.id}`}>
              <Form.Label>
                {question.label}
                {question.required ? '*' : ''}
              </Form.Label>
              {question.type !== CustomQuestionType.TEXT ? (
                renderSelectQuestions({
                  question: question,
                  register: register,
                  errors: errors,
                  loadedViaCode: loadedViaCode,
                  answeredQuestions: answeredCustomQuestions,
                  formState: formState,
                  defaultValue: defaultValue,
                })
              ) : (
                <>
                  <Form.Control
                    {...register(`custom_answer$${question.id}`)}
                    required={question.required}
                    type='text'
                    defaultValue={defaultValue(question)}
                    disabled={
                      loadedViaCode &&
                      answeredCustomQuestions.includes(question.id)
                    }
                    isValid={
                      formState.touchedFields[`custom_answer$${question.id}`] &&
                      !errors[`custom_answer$${question.id}`]
                    }
                    isInvalid={!!errors[`custom_answer$${question.id}`]}
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors[`custom_answer$${question.id}`]
                      ? (errors[`custom_answer$${question.id}`] as FieldError)
                        .message
                      : ''}
                  </Form.Control.Feedback>
                </>
              )}
              <Form.Text className='text-muted'>{question.description}</Form.Text>
            </Form.Group>
          </Col>
        </Form.Row>
      ))}
    </>
  )
}
